import axios from 'axios'; // 引入axios
axios.defaults.withCredentials = true;
// 创建axios实例
const service = axios.create({
  timeout: 5000, // 请求超时时间
});

// service.interceptors.request.use((config) => {
//   return config
// });

// 响应拦截器
service.interceptors.response.use((res) => {
  // throw new Error('asdasdad');
  if (res.status === 200) {
    if (res.data.code === 200) {
      return res.data.data;
    } else {
      const message = res.data.msg || res.data.message || '参数错误，无极处理数据失败！！！';
      return new Error(message);
    }
  } else {
    const message = res.data.msg || res.data.message || '请求接口失败！！！';
    return new Error(message);
  }
});

export default service;
